<template>
  <div>
    <div class="section-title d-flex justify-space-between align-center">
      <div>
        {{ $t("message.common.primaryCategory") }}
      </div>
      <v-btn
        v-if="primaryCategory && canEditFacilityPrimaryCategory"
        icon
        color="primary"
        @click="dialog.add = true"
        :disabled="isReadonly"
      >
        <v-icon>
          icon-edit
        </v-icon>
      </v-btn>
    </div>

    <div v-if="primaryCategory">
      <v-chip outlined class="mr-2 my-1">
        {{ primaryCategory.name }}
      </v-chip>
    </div>
    <ui-button
      v-else-if="canEditFacilityPrimaryCategory"
      color="primary"
      icon="mdi-plus"
      outlined
      block
      @click="dialog.add = true"
      :disabled="isReadonly"
    >
      {{ $t("message.common.add") }}
    </ui-button>

    <v-chip v-else color="grey-darker" class="my-1">
      {{ $t("message.common.noData") }}
    </v-chip>
    <InfoBox
      v-if="canEditFacilityAdditionalCategories && infoBoxText"
      class="mt-2"
      :text="$t(infoBoxText)"
      :more-info-link="
        GMB_VERIFICATION_INFO_LINKS[GMB_CHANGE_FIELD_TYPE.CATEGORY](
          $i18n.locale
        )
      "
    />

    <SectionLoader :status="loading" :opacity="0.5" />

    <AddCategoryDialog
      :isOpen="dialog.add"
      :maxWidth="1154"
      :added-categories-ids="[primaryCategory && primaryCategory.id]"
      :chosen-category-type="categoryTypes.PRIMARY"
      @add="saveCategory"
      @close="dialog.add = false"
    />
  </div>
</template>

<script>
import { CategoryType } from "@/enums/category-type";
import { permissionsInfo } from "@/helpers/mixins/permissions-info";

import SectionLoader from "@/components/Loader/SectionLoader.vue";
import AddCategoryDialog from "@/components/FacilityDetails/Dialog/AddCategoryDialog.vue";
import InfoBox from "@/components/ui/InfoBox.vue";
import {
  GMB_CHANGE_FIELD_TYPE,
  GMB_VERIFICATION_INFO_LINKS
} from "@/helpers/mixins/gmb-update-verification";

export default {
  name: "PrimaryCategory",
  data() {
    return {
      categoryTypes: CategoryType,
      dialog: {
        add: false
      },
      GMB_VERIFICATION_INFO_LINKS,
      GMB_CHANGE_FIELD_TYPE
    };
  },
  mixins: [permissionsInfo],
  components: {
    SectionLoader,
    AddCategoryDialog,
    InfoBox
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    isReadonly: {
      type: Boolean,
      required: true
    },
    primaryCategory: {
      type: Object,
      default: () => {}
    },
    infoBoxText: {
      type: String,
      default: "message.gmbVerification.category"
    }
  },
  methods: {
    saveCategory({ category }) {
      this.$emit("save", { category, type: CategoryType.PRIMARY });
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  @include sectionTitle();
}

.v-chip {
  @include vChip();
  white-space: pre-wrap;
}
</style>
